// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__6i0lv","off":"Modal_off__FCv1Q","modal":"Modal_modal__Us44O"};